import { render, staticRenderFns } from "./SecuritySection.vue?vue&type=template&id=0f8949ba&scoped=true"
import script from "./SecuritySection.vue?vue&type=script&lang=js"
export * from "./SecuritySection.vue?vue&type=script&lang=js"
import style0 from "./SecuritySection.vue?vue&type=style&index=0&id=0f8949ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8949ba",
  null
  
)

export default component.exports